import React from 'react'

const Textarea = ({ disabled = false, required = false, label, name, placeholder, rows = 5, value, onChange, className = '' }) => {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {label && (
        <label htmlFor={name} className="text-lg text-blueDarker font-normal">
          {label}{required && <span className="ml-1.5">*</span>}
        </label>
      )}
      <textarea
        id={name}
        name={name}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        value={value}
        onChange={onChange}
        className="w-full border border-bluePale rounded-xl px-3 py-3 text-base placeholder-blueSteel"
      />
    </div>
  )
}

export default Textarea